<template>
    <v-app id="inspire">
        <v-navigation-drawer v-model="drawer" app clipped>
            <v-list dense>
                <v-list-group v-if="user" :value="true" no-action prepend-icon="mdi-account-circle">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ user.displayName }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item link :to="{ name: 'WeeklySummary' }">
                        <v-list-item-action>
                            <v-icon>mdi-calendar-week</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Weekly Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="logout">
                        <v-list-item-action>
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Sign-out</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-item v-else @click="dialogForSiginIn = true">
                    <v-list-item-action>
                        <v-icon>mdi-login</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Sign-in</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'Calculator' }">
                    <v-list-item-action>
                        <v-icon>mdi-calculator</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Calculator</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-group no-action :value="false" prepend-icon="mdi-history">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>Log</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item link :to="{ name: 'DailyLog' }">
                        <v-list-item-action>
                            <v-icon>mdi-calendar</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Daily Log</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link :to="{ name: 'ExerciseLog' }">
                        <v-list-item-action>
                            <v-icon>mdi-calendar-text</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Exercise Log</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-item @click="install" v-if="showInstall">
                    <v-list-item-action>
                        <v-icon>mdi-download</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Install</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Feedback</v-list-item-title>
                        <v-list-item-subtitle>soonsm@gmail.com</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app clipped-left>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="install" v-if="showInstall">
                <v-icon>mdi-download</v-icon>
            </v-btn>
            <template v-if="$route.meta.title === 'Calculator'">
                <v-btn icon @click="clear">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn icon @click="save">
                    <v-icon>mdi-content-save</v-icon>
                </v-btn>
            </template>
        </v-app-bar>

        <v-content>
            <v-container text-center fluid pa-0>
                <div class="text-center">
                    <v-dialog v-model="dialogForSiginIn" width="500">
                        <v-card>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-btn text @click="login('google')"> <v-icon left>mdi-google</v-icon> Sign in with Google </v-btn>
                                    </v-row>
                                    <v-row>
                                        <v-btn text @click="login('facebook')"> <v-icon left>mdi-facebook</v-icon> Sign in with Facebook </v-btn>
                                    </v-row>
                                    <!--
                                    <v-row>
                                        <v-btn text @click="login('twitter')"> <v-icon left>mdi-twitter</v-icon> Sign in with Twitter </v-btn>
                                    </v-row>
                                    <v-row>
                                        <v-btn text @click="login('github')"> <v-icon left>mdi-github-box</v-icon> Sign in with Github </v-btn>
                                    </v-row>
                                    -->
                                </v-container>
                                No Sign-up is required
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogForLogin" width="500">
                        <v-card>
                            <v-card-text>
                                Sign-in is required
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="dialogForLogin = false">
                                    OK
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogForSafariInstall" width="500">
                        <v-card>
                            <v-card-title class="body-2">
                                <span >Install&nbsp;<span class="title ml-1 mr-1">INOL-LOG</span>on your iPhone</span>
                            </v-card-title>
                            <v-card-text class="d-flex align-end">
                                tap<v-img :src="require('./assets/iphone-upload.png')" max-width="25" max-height="25" class="mx-1"></v-img>and then 'Add to homescreen'.
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="dialogForSafariInstall = false">
                                    OK
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
                <v-fade-transition mode="out-in">
                    <router-view></router-view>
                </v-fade-transition>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

import global from './global.js';

const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};

export default {
    data: () => ({
        dialogForSiginIn: false,
        dialogForLogin: false,
        dialogForSafariInstall: false,
        drawer: null,
        user: JSON.parse(localStorage.getItem('user')),
        deferredPrompt: null,
        showInstall: false,
    }),
    methods: {
        showInstallPromotion: function() {
            this.showInstall = true;
        },
        install: function() {
            if (isIos()) {
                this.dialogForSafariInstall = true;
            } else {
                this.deferredPrompt.prompt();
                // Wait for the user to respond to the prompt
                this.deferredPrompt.userChoice.then(choiceResult => {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the A2HS prompt');
                    } else {
                        console.log('User dismissed the A2HS prompt');
                    }
                    this.deferredPrompt = null;
                    this.showInstall = false;
                });
            }
        },
        save: function() {
            global.bus.$emit('calculatorSave');
        },
        clear: function() {
            global.bus.$emit('calculatorClear');
        },
        addMyExercise: function() {
            global.bus.$emit('addMyExercise');
        },
        deleteMyExercise: function() {
            global.bus.$emit('deleteMyExercise');
        },
        login: function(social) {
            let provider;
            switch (social) {
                case 'google':
                    provider = new firebase.auth.GoogleAuthProvider();
                    provider.setCustomParameters({
                        prompt: 'select_account',
                    });
                    break;
                case 'facebook':
                    provider = new firebase.auth.FacebookAuthProvider();
                    break;
                default:
                    return;
            }
            firebase
                .auth()
                .signInWithPopup(provider)
                .then(() => {
                    //Browser를 닫으면 세션이 종료되도록 설정
                    // firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
                    this.dialogForSiginIn = false;
                    this.drawer = false;
                })
                .catch(err => {
                    alert(err.message);
                });
        },
        logout: function() {
            if (this.user) {
                firebase.auth().signOut();
                // if(this.$route.path !== 'calculator'){
                //     this.$router.push({ path: 'calculator' });
                // }
                this.drawer = false;
            }
        },
    },
    beforeCreate() {
        // this.user = JSON.parse(localStorage.getItem('user'));
    },
    created() {
        this.$vuetify.theme.dark = true;
        /**
         * 새로고침 하거나, 브라우저를 껐다가 켜도 세션에서 사용자 정보를 읽어오기 때문에 onAuthStateChanged를 등록해준다.
         */
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.user = user;

                const parsed = JSON.stringify(this.user);
                localStorage.setItem('user', parsed);
            } else {
                this.user = null;
                localStorage.removeItem('user');
            }
        });
        this.$router.beforeEach((to, from, next) => {
            try {
                if (to.matched.some(record => record.meta.requiresAuth)) {
                    if (!this.user) {
                        this.dialogForLogin = true;
                        next(false);
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            } catch (e) {
                console.log(JSON.stringify(e));
            }
        });

        window.addEventListener('beforeinstallprompt', e => {
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e;
            // Update UI notify the user they can add to home screen
            this.showInstallPromotion();
        });

        window.addEventListener('appinstalled', evt => {
            console.log(JSON.stringify(evt));
        });

        // Detects if device is on iOS

        // Detects if device is in standalone mode
        const isInStandaloneMode = () => 'standalone' in window.navigator && window.navigator.standalone;

        // Checks if should display install popup notification:
        if (isIos() && !isInStandaloneMode()) {
            this.showInstallPromotion();
        }
    },
};
</script>
